import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $charge, $inputs } = this;

  return (view = ViewFactory({
    NAME: 'FAWRYPAY_INIT_VIEW',
    inputs: ['phone'],
    constants: { hasBackAction: false },
    next() {
      const phonenumber = getValueAtPath($inputs, '[phone].value');

      if (phonenumber) {
        $charge.init({
          data: { phonenumber }
        });
      }
    }
  }).call(this));
}
